export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'Home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'Dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    // {
    //   name: 'reports',
    //   displayName: 'Relatórios',
    //   meta: {
    //     icon: 'vuestic-iconset-tables',
    //   },
    // },
    // {
    //   name: 'users',
    //   displayName: 'Usuários',
    //   meta: {
    //     icon: 'group',
    //   },
    // },
    // {
    //   name: 'professionals',
    //   displayName: 'Profissionais',
    //   meta: {
    //     icon: 'business_center',
    //   },
    // },
    // {
    //   name: 'companies',
    //   displayName: 'Empresas',
    //   meta: {
    //     icon: 'business_center',
    //   },
    // },
    {
      name: 'customers',
      displayName: 'Funcionários',
      meta: {
        icon: 'contacts',
      },
    },
    // {
    //   name: 'sales',
    //   displayName: 'Pedidos',
    //   meta: {
    //     icon: 'shopping_cart',
    //   },
    // },
    // {
    //   name: 'invoices',
    //   displayName: 'Notas Fiscais',
    //   meta: {
    //     icon: 'receipt_long',
    //   },
    // },
    // {
    //   name: '#',
    //   displayName: 'Configurações',
    //   meta: {
    //     icon: 'settings',
    //   },
    //   children: [
    //     {
    //       name: 'tags',
    //       displayName: 'Tags de Produtos',
    //     },
    //   ],
    // },
    // {
    //   name: 'projects',
    //   displayName: 'menu.projects',
    //   meta: {
    //     icon: 'folder_shared',
    //   },
    // },
    // {
    //   name: 'payments',
    //   displayName: 'menu.payments',
    //   meta: {
    //     icon: 'credit_card',
    //   },
    //   children: [
    //     {
    //       name: 'payment-methods',
    //       displayName: 'menu.payment-methods',
    //     },
    //     {
    //       name: 'pricing-plans',
    //       displayName: 'menu.pricing-plans',
    //     },
    //     {
    //       name: 'billing',
    //       displayName: 'menu.billing',
    //     },
    //   ],
    // },
    // {
    //   name: 'auth',
    //   displayName: 'menu.auth',
    //   meta: {
    //     icon: 'login',
    //   },
    //   children: [
    //     {
    //       name: 'login',
    //       displayName: 'menu.login',
    //     },
    //     {
    //       name: 'signup',
    //       displayName: 'menu.signup',
    //     },
    //     {
    //       name: 'recover-password',
    //       displayName: 'menu.recover-password',
    //     },
    //   ],
    // },
    //
    // {
    //   name: 'faq',
    //   displayName: 'menu.faq',
    //   meta: {
    //     icon: 'quiz',
    //   },
    // },
    // {
    //   name: '404',
    //   displayName: 'menu.404',
    //   meta: {
    //     icon: 'vuestic-iconset-files',
    //   },
    // },
    // {
    //   name: 'preferences',
    //   displayName: 'menu.preferences',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    // },
    // {
    //   name: 'my-account',
    //   displayName: 'Minha ',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    // },
    // {
    //   name: 'settings',
    //   displayName: 'Configurações',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
  ] as INavigationRoute[],
}
